import { Link } from "react-router-dom"
import { SiteFooter } from "../../components/SiteFooter.js"
import styles from "./DisclaimerPage.module.css"

export function DisclaimerPage() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.backLink}>
            ← 一覧に戻る
          </Link>
          <span className={styles.siteName}>株主優待図鑑</span>
        </div>
      </header>

      <main className={styles.main}>
        <h1 className={styles.title}>データの出典・免責事項</h1>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>株価・時価総額等のデータの出典</h2>
          <p>
            株価・時価総額・配当利回り・優待利回りは、
            <a
              href="https://disclosure2.edinet-fsa.go.jp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              EDINET閲覧（提出）サイト
            </a>
            で公開されている有価証券報告書のデータをもとに、当サイト（株主優待図鑑）が独自に算出・加工した
            概算値です。金融庁が公表した数値そのものではありません。
          </p>
          <p>
            出典: EDINET閲覧（提出）サイト、
            <a
              href="https://disclosure2dl.edinet-fsa.go.jp/guide/static/disclosure/WZEK0030.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              PDL1.0
            </a>
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>数値の正確性について</h2>
          <p>
            上記の概算値は、金融庁が公表した数値そのものではなく、正確性・完全性を保証するものではありません。
          </p>
          <p>
            これらの概算値は、各社の直近の有価証券報告書における
            <strong>事業年度末時点</strong>
            の株価水準（PER×EPSから逆算）に基づいており、現在の実勢株価を示すものではありません。年1回程度の
            更新頻度のため、最新の株価とは乖離している場合があります。
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>会社規模（小型株・中型株・大型株）の区分について</h2>
          <p>
            当サイトが表示する「小型株・中型株・大型株」の区分は、東京証券取引所が定める公式の区分
            （TOPIX Core30・Large70・Mid400・Small、上場銘柄全体の中での時価総額・流動性の
            <strong>順位</strong>
            によって決まる）とは異なります。当サイトは自社がクロールした一部の銘柄のデータしか保有しておらず、
            上場銘柄全体での順位を算出できないため、時価総額1,000億円以下を小型株、1,000億〜5,000億円を
            中型株、5,000億円以上を大型株とする、証券会社・金融メディアで目安として使われることのある
            金額区分を採用しています。法律や業界統一の基準ではない、当サイト独自の目安である点にご留意ください。
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>投資判断について</h2>
          <p>
            当サイトは投資助言を目的としたものではなく、特定の銘柄の売買を推奨するものではありません。掲載情報は
            参考情報の一つに過ぎず、投資に関する最終的な判断は、利用者ご自身の責任において行ってください。当サイトの
            情報を利用したことにより生じたいかなる損害についても、当サイトは責任を負いません。
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>株主優待情報の出典について</h2>
          <p>
            株主優待の内容（上記の株価・時価総額等とは別のデータソースです）は、各社の公式サイト等の
            公表資料をもとに当サイトが作成していますが、優待制度は予告なく変更・廃止される場合があります。
            最新の優待内容は、必ず各社の公式発表でご確認ください。
          </p>
        </section>
      </main>

      <SiteFooter />
    </div>
  )
}
